export class About {
    version;
    constructor(cfg = {}) {
        const { version = '1.0.3' } = cfg;
        this.version = version;
    }
    static fromJSON(aboutJSON) {
        const _about = JSON.parse(aboutJSON);
        return new About(_about);
    }
}
